'use client';

import * as React from 'react';

import { useToggle } from '@hooks';
import type { Feature } from '@gql';

import { FeaturesSection } from './features-section';

interface ListingAmenitiesSectionProps {
  features: Pick<
    Feature,
    'key' | 'displayName' | 'categoryName' | 'promoted'
  >[];
}

export const ListingAmenitiesSection: React.FC<
  ListingAmenitiesSectionProps
> = ({ features }) => {
  const { on: showAllAmenities, toggle: toggleShowAllAmenities } =
    useToggle(false);

  return (
    <FeaturesSection
      features={features}
      showAllEnabled={showAllAmenities}
      toggleShowAll={toggleShowAllAmenities}
    />
  );
};
